import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '@env/environment'
import { AppErrorPayload } from '../data-types/app-error'

@Injectable({ providedIn: 'root' })
export class LogAppErrorCommand {
  constructor(private httpClient: HttpClient) {}

  call(payload: AppErrorPayload): void {
    const url = `${environment.api.appErrors}/log`

    this.httpClient.post(url, payload).subscribe({
      error: (err) => {
        console.error('[LogAppErrorCommand] failed:', err?.status, err?.message)
      },
    })
  }
}
